(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdp-adv-cta"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var el = document.querySelector('[data-adv-sticky]');
    if(!el) return;
    var shown = false;
    function onScroll(){
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if(y > 700 && !shown){ el.classList.add('is-on'); shown = true; }
      else if(y <= 700 && shown){ el.classList.remove('is-on'); shown = false; }
    }
    window.addEventListener('scroll', onScroll, { passive:true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();
})();
